import { useEnvContext } from "next-runtime-env";

export const createImageUrl = (imgUrl, scale, crop) => {
  const { NEXT_PUBLIC_EJ_CDN_IMAGES_HOSTNAME } = useEnvContext();
  let url = null;
  if (!imgUrl) {
    url = "/assets/images/no_photo_big.jpg";
    return url;
  }
  const resizeMethod = crop ? "cropresize" : "resize";
  const hostUrl = NEXT_PUBLIC_EJ_CDN_IMAGES_HOSTNAME;
  const urlPartToScale = scale ? `/${resizeMethod}/${scale.width}/${scale.height}` : "";
  url = `${hostUrl}${urlPartToScale}${imgUrl?.replace(process.env.EJ_CDN_IMAGES_HOSTNAME, "")}`;
  return url;
};
